module.exports = __webpack_public_path__ + "img/xia2.ef4fd642.png";